<router-outlet #childOutlet="outlet"></router-outlet>
<div [hidden]="childOutlet.isActivated">
<main class="container py-4">
    @if (address.includes('travel') || address.includes('bill') || address.includes('lifestyle')) {
        <app-nav-header
        pageTitle="Frequently Asked Questions"
        pageTitleCss="text-black"
    ></app-nav-header>
    }
    @else {
        <app-nav-header
        (back)="onBack()"
        pageTitle="Frequently Asked Questions"
        pageTitleCss="text-black"
        routeTo="gethelp"
    ></app-nav-header>
    }
    
    <mat-accordion class="mb-4 pt-8" multi>
    <mat-expansion-panel
        (closed)="policiesService.removeStep(-1)"
        (opened)="policiesService.addStep(0)"
        [expanded]="policiesService.steps.includes(0)">
        <mat-expansion-panel-header>
            <mat-panel-title>General Enquiries</mat-panel-title>
        </mat-expansion-panel-header>
    </mat-expansion-panel>
    <mat-expansion-panel
        (closed)="policiesService.removeStep(-1)"
        (opened)="policiesService.addStep(1)"
        [expanded]="policiesService.steps.includes(1)">
        <mat-expansion-panel-header>
            <mat-panel-title>Travel Protect Plus</mat-panel-title>
        </mat-expansion-panel-header>

        <section class="border-t border-t-[#EAECF0] pt-4">
            <app-travel-policy-faq-panel></app-travel-policy-faq-panel>
        </section>
    </mat-expansion-panel>
    </mat-accordion>
</main>
</div>